//Mã nguồn NSNN
export default {
  General: 0, // không chọn
  DomesticExpenditure: 1, // nguồn chi từ vốn trong nước
  ForeignExpenditure: 50 // nguồn chi từ vốn ngoài nước
};
